import React, { useState } from 'react';

const Tooltip = ({ children, content, placement = 'top' }) => {
    const [isVisible, setIsVisible] = useState(false);

    // Configuraciones de posición para el tooltip
    const positionClasses = {
        top: 'bottom-full left-1/2 -translate-x-1/2 mb-2',
        bottom: 'top-full left-1/2 -translate-x-1/2 mt-2',
        left: 'right-full top-1/2 -translate-y-1/2 mr-2',
        right: 'left-full top-1/2 -translate-y-1/2 ml-2'
    };

    // Flechitas indicadoras (opcional, para estética)
    const arrowClasses = {
        top: 'top-full left-1/2 -translate-x-1/2 border-t-white/20 border-l-transparent border-r-transparent border-b-transparent',
        bottom: 'bottom-full left-1/2 -translate-x-1/2 border-b-white/20 border-l-transparent border-r-transparent border-t-transparent',
        left: 'left-full top-1/2 -translate-y-1/2 border-l-white/20 border-t-transparent border-b-transparent border-r-transparent',
        right: 'right-full top-1/2 -translate-y-1/2 border-r-white/20 border-t-transparent border-b-transparent border-l-transparent'
    };

    return (
        <div
            className="relative flex items-center justify-center"
            onMouseEnter={() => setIsVisible(true)}
            onMouseLeave={() => setIsVisible(false)}
        >
            {/* Elemento que activa el tooltip */}
            {children}

            {/* Tooltip con animación */}
            <div
                className={`
          absolute z-50 whitespace-nowrap px-3 py-1.5 
          bg-gray-900/90 backdrop-blur-md 
          border border-white/20 text-white text-sm font-medium rounded-lg shadow-xl
          pointer-events-none transition-all duration-200 ease-out
          ${positionClasses[placement]}
          ${isVisible ? 'opacity-100 scale-100 translate-y-0' : 'opacity-0 scale-95'}
        `}
            >
                {content}

                {/* Flechita del tooltip */}
                {/* <div className={`absolute w-0 h-0 border-4 ${arrowClasses[placement]}`} /> */}
            </div>
        </div>
    );
};

export default Tooltip;
